var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('new-element-chooser',{ref:"dialog",attrs:{"icon":_vm.icon,"title":"Add Label Generator","width":"500"}},[_c('new-element-entry',{attrs:{"icon":"fa-globe","item-id":"qr-code"},on:{"chosen":_vm.onChosen}},[_vm._v("QR Code Generator")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }